import { Box, Loader, Flex } from '@mantine/core';
import { LoginForm } from '@shared/ui';
import { ResetPassword } from '@features/auth';
import { useShowMe, useAuth } from '@entities/auth';

export const ResetPasswordPage = () => {
  const { isLoading: isLoadingShowMe } = useShowMe();
  const { isAuthenticated } = useAuth();

  if (isLoadingShowMe || isAuthenticated) {
    return (
      <Flex justify='center' w='100%'>
        <Loader size='lg' />
      </Flex>
    );
  }

  return (
    <LoginForm
      title='Восстановление пароля'
      description='Пожалуйста, задайте новый надёжный пароль для входа в личный кабинет'
    >
      <Box pt='2rem'>
        <ResetPassword />
      </Box>
    </LoginForm>
  );
};
